import Breadcrumbs from './Breadcrumbs.vue';
import BreadcrumbsItem from './BreadcrumbsItem.vue';

export {BreadcrumbsItem};
export default Breadcrumbs;
